export class CreateCustomerTokenDialogContext {
    phone: string;
  }